import styled from "styled-components";
import { between, up, down } from "styled-breakpoints";
import our_farm_banner from "../../../../assets/images/our_farm_banner.jpg";

export const Wrapper = styled.div`
  .first_content {
    background: linear-gradient(
        180deg,
        rgba(20, 70, 8, 0.56) 58.5%,
        rgba(49, 172, 20, 0) 100%
      ),
      url(${our_farm_banner});
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat;
    width: 100vw;
    min-height: 498px;
    display: flex;
    align-items: center;
    margin: auto;
    justify-content: center;
    ${down("md")} {
      min-height: 390px;
      background: linear-gradient(
          180deg,
          rgba(20, 70, 8, 0.56) 58.5%,
          rgba(49, 172, 20, 0) 100%
        ),
        url(${our_farm_banner});
    }
    div {
      width: 76vw;
      display: flex;
      margin: auto;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #ffff;
      row-gap: 2rem;
      ${down("md")} {
        height: 100%;
        width: 90vw;
        row-gap: 1rem;
        align-items: start;
        justify-content: start;
        padding: 120px 0;
      }
      form {
        background: rgba(243, 250, 242, 1);
        overflow: hidden;
        width: 50%;
        position: relative;
        border-radius: 60px;
        min-width: 440px;
        margin: auto;
        ${down("md")} {
          width: 50%;
        }
        ${down("sm")} {
          min-width: 250px;
          width: 100%;
        }
        input[type="email"] {
          background: inherit;
          padding: 17px;
          padding-inline-end: 120px;
          padding-inline-start: 35px;
          width: 100%;
          color: rgb(0 0 0);
          font-size: 12px;
          line-height: 19.89px;
          color: #0b9c07;
          font-weight: 500;
          transition: all 2.3s ease-in;
          font-family: 'Saira';
          ${down("md")} {
            padding: 14px;
            font-size: 12px;
            font-weight: 400;
            line-height: 19.89px;
            padding-inline: 32px 89px;
          }
        }
        input::placeholder {
          color: #808080;
        }
        span.search {
          position: absolute;
          font-size: 14px;
          top: 0;
          /* padding: 15px 30px 15px 30px; */
          /* bottom: 50%; */
          right: 100%;
          /* top: 0; */
          transform: translate(0, -50%);
          left: 10px;
          top: 50%;
        }
        button {
            position: absolute;
            font-size: 14px;
            top: 50%;
            padding: 23px 16px;
            bottom: 50%;
            right: 6px;
            transform: translateY(-50%);
            border-width: medium;
            border-style: none;
            border-color: currentcolor;
            border-image: none;
            cursor: pointer;
            transition: background-color 0.3s;
            font-weight: 700;
            font-family: 'Saira';

          ${down("md")} {
            font-size: 12.17px;
            line-height: 19.16px;
            letter-spacing: -0.06em;
            padding: 20px 11px;
            font-weight: 600;
          }
          .subscribe{
            font-size: larger;
          }
        }
      }
      h4 {
        font-size: 40px;
        font-weight: 600;
        line-height: 48px;
        letter-spacing: -0.03em;
        text-align: center;
        ${down("md")} {
          font-size: 28.93px;
          font-weight: 600;
          line-height: 28.8px;
          letter-spacing: -0.03em;
        }
      }
      p {
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        ${down("md")} {
          font-size: 14px;
          font-weight: 400;
          line-height: 120%;
        }
      }
    }
    ${up("md")} {
      max-height: 1440px;
      width: 100%;
    }

    .banner_text {
      width: 100%;
      margin: auto;
    }
  }
`;
